import {charcoal} from '../../sass/v2/_exports.sass';

export const WorldIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 2.66667C8.64799 2.66667 2.66666 8.64801 2.66666 16C2.66666 23.352 8.64799 29.3333 16 29.3333C23.352 29.3333 29.3333 23.352 29.3333 16C29.3333 8.64801 23.352 2.66667 16 2.66667ZM5.33332 16C5.33332 14.8013 5.54132 13.6507 5.90799 12.5747L10.6667 17.3333V20L14.6667 24V26.5747C9.41466 25.9147 5.33332 21.4293 5.33332 16ZM24.44 22.4973C23.5693 21.796 22.2493 21.3333 21.3333 21.3333V20C21.3333 19.2928 21.0524 18.6145 20.5523 18.1144C20.0522 17.6143 19.3739 17.3333 18.6667 17.3333H13.3333V13.3333C14.0406 13.3333 14.7188 13.0524 15.2189 12.5523C15.719 12.0522 16 11.3739 16 10.6667V9.33334H17.3333C18.0406 9.33334 18.7188 9.05239 19.2189 8.55229C19.719 8.05219 20 7.37392 20 6.66667V6.11867C23.904 7.70401 26.6667 11.5333 26.6667 16C26.6664 18.3529 25.883 20.6389 24.44 22.4973Z"
        fill={color}
      />
    </svg>
  );
};
